export const LEGACY_SPORT_GROUPNAME_LABEL = 'Legacy'

export const SELECT_SPORT_LICENSE_PROPERTY_LABEL = 'License Sport Property'

export const SPORT_LICENSE_PROPERTY_AUTOCOMPLETE_TEST_ID =
  'sport-license-property-autocomplete-test-id'

export const LICENSE_SPORTS_MAP: Record<string, string> = {
  'american-football': 'american football',
  basketball: 'basketball',
  cricket: 'cricket',
  snooker: 'snooker',
  soccer: 'soccer',
  tabletennis: 'table tennis',
  volleyball: 'volleyball'
}
